/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://hbbse2vcmfh55nwqph3vlpmywi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-vwsywdbmuvcirasbwkphoca2zq",
    "aws_cognito_identity_pool_id": "us-east-1:5ce96275-1e84-4d5a-b2d7-e80a9b355baa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_IKZkx3J3i",
    "aws_user_pools_web_client_id": "4khe53kv63rtngbntm79cf8t7o",
    "oauth": {
        "domain": "proctorappef460eeb-ef460eeb-liveproc.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://www.monitoredu.live/proctor/,https://dev.monitoredu.live/proctor/,https://mod.monitoredu.live/,http://localhost:5173/proctor/",
        "redirectSignOut": "http://localhost:3000/,https://www.monitoredu.live/,https://dev.monitoredu.live/,https://mod.monitoredu.live/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplify-d1hm6gwkw41fxx-ma-candidatefilesbucketc82c-dyari4ttrrbp",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
